export const API_ERROR = "api_failed";

export const SETTINGS_DATA = "SETTINGS_data";
export const SETTINGS_DATA_SUCCESS = "SETTINGS_data_success";
export const SETTINGS_SAVE = "SETTINGS_save";
export const SETTINGS_SAVE_SUCCESS = "SETTINGS_save_success";

export const SETTINGS_INPUT_CHANGEVALUE = "SETTINGS_input_ChangeValue";